import { render, staticRenderFns } from "./RiskListFiltering.vue?vue&type=template&id=28cb1a06&scoped=true&"
import script from "./RiskListFiltering.vue?vue&type=script&lang=js&"
export * from "./RiskListFiltering.vue?vue&type=script&lang=js&"
import style0 from "./RiskListFiltering.vue?vue&type=style&index=0&id=28cb1a06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28cb1a06",
  null
  
)

export default component.exports